import { FilterDialogListType } from './dataflow';

export interface IDepartmentInfo {
    department_id: string;
    department_name: string;
    is_del: string;
}

export interface IDepartmentList {
    department_id: string;
    department_name: string;
    parent_department_id: string;
    member_count: number;
    show_index: string;
    enterprise_id: string;
    level: string;
    have_child_departments_flag: number;
    is_del: number;
    manage_permission?: number;
    managers: IMemberList[];
    child_path: IDepartmentInfo[];
    parent_path: IDepartmentInfo[];
    children?: IDepartmentList[];
}

export enum TravelType {
    department = 'department', // 部门模式
    owner = 'owner', // 负责人模式
}
export enum SectionType {
    left = 'left', // 部门模式
    right = 'right', // 负责人模式
}

export enum DEPARTMENT_ACCESS {
    ADMIN = 0, // 无限制
    DEPARTMENT_HEAD = 1, // 部门负责人负责的部门
    DEPARTMENT_MANAGE = 2, // 子管理员管理的部门
    DEPARTMENT_HEAD_MANAGE = 3, // 负责的部门 + 管理的部门
}

export interface IDepartment {
    parents: IDepartment;
    children?: IDepartment[];
    name: string;
}

export interface IMemberList {
    member_id: string;
    user_info: IUserInfo;
    department_id: number;
    role: number;
    role_type: string;
    number: string;
    name: string;
    isSelect: boolean;
    isSelected?: boolean;

    id?: string;
    user_name?: string;
    avatar?: string;
}

export interface IMemberListInfo {
    page_info: IPageInfo;
    list: IMemberList[];
    requestId?: Symbol;
}

export interface IListItem {
    type: TravelType;
    id: string;
    isSelected: boolean;
    name: string; // 内容
    avatar?: string;
    oriData?: any;
    isHaveNextLevel?: boolean;
    checkable?: boolean;
    role?: RoleType;
    isDisabledNextLevel?: boolean;
    user_department_path?: string;
    manage_permission?: number;
    is_hidden_member_count?: boolean;
}

export enum RoleType {
    admin = 2, // 负责人
    ordinary = 1, // 普通
    unknown = 0, // 未知
}

/**
 * @description: 面包屑结构, 根据 support_modules 定的
 * path:
 * href:
 */
export interface IRoute {
    path?: string;
    href?: string;
    name: string;
}

export type DefaultSelectDepartmentItem = {
    id: string;
    exclude_umu_ids?: [];
};

export type DefaultSelectDepartmentMemberItem = {
    id: string;
};

export interface IListProps {
    useId: string;
    type: TravelType;
    isFromDrop?: boolean; // 是否下拉选择框
    section: SectionType;
    departmentId?: string;
    btnType?: string;
    expendParams?: {
        [propName: string]: string;
    }; // 接口额外扩展参数
    excludeDepartmentIds?: string; // 排除的部门id，包括其子部门
    isRadio?: boolean;
    source?: string;
    clsName?: string;
    isAllowSelect?: boolean; // 是否展示全选
    isShowMember?: boolean; // 是否展示成员数量
    allSelectText?: string; // 全选展示文案
    limit?: number; // 多选限制
    access?: DEPARTMENT_ACCESS;
    dataRemoveCb?(key: number, item: IListItem): void;
    dataAddCb?(key: number, item: IListItem): void;
    clean?(): void;
    isLoading?: boolean;
    setIsLoading?: (value: boolean) => void;
    defaultSelectedList?: string;
    defaultSelectedMemberList?: { id: string }[];
    isOnlyShowRightList?: boolean;
    isShowNotInSeDepartment?: boolean; // 是否展示不在 USE 部门的部门选项
    notInSeDepartmentLabel?: string; // 不在 USE 部门的部门选项文案
    notInSeDepartmentValue?: string; // 不在 USE 部门的部门选项值
    isOnlyShowUSESelectedDepartment?: boolean;
    isCanClickOriginStructure?: boolean;
    isMutualExclusionOfNotInSeDepartment?: boolean;
    isCanSelectParentDepartment?: boolean;
    defaultSelectedDepartmentList?: DefaultSelectDepartmentItem[];
}

export interface IDListRef {
    cleanStateByParent: () => void;
}

export type MemberItemOriData = {};

export type MemberItem = {
    page_info: IPageInfo;
    list: IListItem[];
    type: FilterDialogListType;
};

export type SugMemberListParams = {
    page: number;
    size: number;
    keyword: string;
    department_id: string;
    exclude_resigned_user: number; //  1为过滤离职用户，0不过滤离职用户
};

export interface ISubDepartInfo {
    department_id: string;
    member_count: string;
    department_name: string;
    parent_department_id: string;
    enterprise_show_name?: string;
    managers: IMemberList[];
    child_path: IDepartmentList[];
    parent_path: IDepartmentList[];
    manage_permission?: number;
}

export type ISugDepartListInfo = {
    department_id: string;
    department_name: string;
    manage_permission?: number;
    parent_path: IDepartmentList[];
};

export type RequestResponse<T> = {
    error_message: string;
    error_code: string | number;
    data: T;
};

export type GetDepartmentData = {
    id: string;
    name: string;
    parent_id: string;
    disabled?: boolean;
    path?: string | string[];
    children: GetDepartmentData[];
};
